export const REVISION_KEY = {
  SOIL_TYPE: 'selected_soil_type_revision',
  STAGE_CONFIGURATION: 'selected_stage_configuration_revision',
  WATER_LINE_RULE: 'selected_water_line_rule_revision',
  BURSTING_PARAMETER: 'selected_bursting_parameter_revision'
}

export const ADMIN_ROLE = 'admin'
export const CONTRIBUTOR_ROLE = 'contributor'
export const VIEWER_ROLE = 'viewer'
